import { useFormatCoin } from '@mgonetwork/core';
import { type CoinStruct } from '@mgonetwork/mango.js/client';
import { Text } from '@mgonetwork/ui';

import { ObjectLink } from '~/ui/InternalLink';

type CoinItemProps = {
	coin: CoinStruct;
};

export default function CoinItem({ coin }: CoinItemProps) {
	const [formattedBalance, symbol] = useFormatCoin(coin.balance, coin.coinType);
	return (
		<div className="defined-bg-black flex items-center justify-between rounded-lg px-3 py-2 shadow-panel">
			<ObjectLink objectId={coin.coinObjectId} className="defined-coin-text" />
			<div className="col-span-3 mr-19 inline-flex items-center gap-1">
				<Text color="hero-dark" variant="bodySmall/medium">
					{formattedBalance}
				</Text>
				<Text color="steel-darker" variant="subtitleSmallExtra/normal">
					{symbol}
				</Text>
			</div>
		</div>
	);
}
